import React from "react"
import TableHeaderColumn from "material-ui/Table/TableHeaderColumn"
import autobind from "class-autobind"
import moment from "moment"
import { ITimecardDay } from "../../models"
interface IProps {
    date: number
    timecardDay: ITimecardDay
    openDailyHistoryDrawer(date: number): void
}
interface IState {
    infoIconHover: boolean
}

export default class EquipmentTimecardTableHeaderItem extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            infoIconHover: false
        }
        autobind(this)
    }

    render() {
        const startDayTime = this.props.timecardDay.LocalStartDayTime.endsWith("Z") ?
            this.props.timecardDay.LocalStartDayTime :
            this.props.timecardDay.LocalStartDayTime + "Z"
        return (
            <TableHeaderColumn style={{ textAlign: "left" }}>
                <div style={{ display: "inline-block", position: "absolute", top: 18, left: 8 }}>
                    <i
                        className="fa fa-info-circle"
                        style={{
                            marginRight: 5,
                            color: this.state.infoIconHover ? "#666666" : "#aaaaaa",
                            cursor: "pointer",
                            display: "inline-block"
                        }}
                        onMouseOver={() => this.setState({ infoIconHover: true })}
                        onMouseOut={() => this.setState({ infoIconHover: false })}
                        onClick={() => this.props.openDailyHistoryDrawer(this.props.date)}
                    />
                </div>
                <div style={{ display: "inline-block" }}>
                    <div style={{ fontSize: 18 }}>{moment(startDayTime).utc().format("dddd")}</div>
                    <div style={{ fontSize: 12, color: "#cccccc", width: "100%" }}>{moment(startDayTime).utc().format("MMMM DD")}</div>
                </div>
            </TableHeaderColumn>
        )
    }
}